<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import ArrayUtil from '../utilities/ArrayUtil'
import BrowserDataUtil from '../utilities/BrowserDataUtil'
import AppResourceUtil from '../utilities/AppResourceUtil'
/** API */
import UserApi from '../api/UserApi'
import IssueApi from '../api/IssueApi'
// import AnnouncementApi from '../api/AnnouncementApi'
/** UI Components */
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Modal } from 'buefy/dist/components/modal'

import LoginAnnouncements from '../components/LoginAnnouncements'
import LoginReportTracker from '../components/LoginReportTracker'

export default {
    name : "LoginView",
    components : {
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-modal' : Modal,
        LoginAnnouncements,
        LoginReportTracker
    },
    data(){
        return {
            isLoading : false,
            username : "",
            password : "",
            errorData : null,
            labelPosition : "on-border",
            showForgotModal : false,
            forgotData : {
                username : "",
                email : ""
            },
            cancelOpts : ["escape","x"],
            isCapsOn : false,
            activeTab: 'posts',  // or tracker
            showForm: false
        }
    },
    computed : {
        ...mapState({
            activeNav : "activeNav",
            profile : "userProfile",
            token : "xOreAuth"
        }),
        isEmailValid(){
            let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
            if (this.forgotData.email.trim()=="") {
                return false
            }
            return (regExp.test(this.forgotData.email));
        }
    },
    created(){
        // Remove session data from client-side
        this.clearData();
    },
    methods: {
        ...mapMutations({
            setActiveNav : "updateActiveNav", 
            setProfile : "updateUserProfile",
            clearAppData : "clearAppData",
            setToken : "udpateAuthToken"
        }),
        checkUser(){
            this.closeError()
            if (!this.username || this.username.trim().length==0) {
                this.showInvalidCreds()
                return false;
            }
            if (!this.password || this.password.trim().length==0) {
                this.showInvalidCreds()
                return false;
            }
            this.isLoading = true;
            this.resetErrorMessage();

            UserApi.login({
                username : this.username,
                password : this.password
            })
            .then(response=>{
                this.isLoading = false;
                if (response.data) {
                    if (!response.data.length) {
                        this.errorData = {};
                        this.errorData.title = response.data.status
                        this.errorData.message =  response.data.message
                        this.isLoading = false;
                        return false;
                    } 
                    else {
                        var user = response.data[0];
                        let page = "";
                        switch(user.role) {
                            case "Admin" :
                                // page = '/admin-dashboard';
                                break;
                            case "Independent Administrator" :
                                // page = '/ia-dashboard';
                                break;
                            case "Data Compliance Officer":
                                // page = '/dashboard';
                                break;
                            case "Authorized Representative":
                                // page = '/dashboard';
                                break;
                            default:
                                // Show error
                                // You're not allowed to access this page
                                this.showAccessDenied()
                                return false
                                break;
                        }
                                                
                        // Set store data
                        this.setProfile(user);
                        this.setToken(user.token);
                        
                        // Set browser data
                        BrowserDataUtil.setProfile(this.$cookies,user);
                        BrowserDataUtil.setToken(this.$cookies,user.token);

                        this.$router.push({path:'/'});
                    }
                }
                else {
                    this.showAccountErr()
                    return false;
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.login');
                this.isLoading = false;
            });
        },
        closeError(){
            this.errorData = null;
        },
        clearData(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
        },
        logOut(){
            this.$router.push({path:"/login"});
        },
        checkCaps(evt,field){
            this.isCapsOn = false;
            if (evt.getModifierState("CapsLock")) {
                if (field=='pwd') {
                    this.isCapsOn = true;
                }
            }
        },
        resetErrorMessage(){
            this.errorData = null;
        },
        openForgotPassword(){
            this.showForgotModal = true;
            this.forgotData.username = "";
            this.forgotData.email = "";
        },
        closeForgotModal(){
            this.showForgotModal = false;
            this.forgotData.username = "";
            this.forgotData.email = "";
        },
        submitForgotData(){
            if (this.forgotData.email.trim()=="" &&
                this.forgotData.username.trim()=="") {
                return false;
            }

            let obj = {
                email : this.forgotData.email,
                username : this.forgotData.username,
                message : "Reset Password",
                issueStatus : "Pending",
                issueType : "Support"
            };

            // Add issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: 'Report submitted. A notification will be sent to '+this.forgotData.email+' once your account has been reset.',
                            type: 'is-success',
                            onConfirm : ()=>{
                                this.closeForgotModal()
                            }
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: 'Unable to submit report. Please try again later.',
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        submitError(errorData,api){

            let obj = {
                email : '',
                username : '',
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        showPosts () {
            this.activeTab = 'posts'
        },
        showTracker () {
            this.activeTab = 'tracker'
        },
        showLoginForm () {
            this.showForm = !this.showForm
        },
        showAccessDenied () {
            this.setLoginError('Access denied',"You're are not permitted to view this page. Please contact the administrator.")
        },
        showInvalidCreds () {
            this.setLoginError('Invalid username and/or password',"Please check your input.")
        },
        showAccountErr () {
            this.setLoginError("Account not found.", "Please check and try again.")
        },
        setLoginError (title, msg) {
            this.errorData = {}
            this.errorData.title = title
            this.errorData.message = msg
        }
    }
}
</script>

<template>
    <section class="section login-body">    

        <div class="columns">
            <div class="column is-one-quarter"> 
                <div class="login-box has-text-left">
                    <div class="has-text-centered">
                        <img align="center" 
                            src="static/img/Logo-Small.png"
                            style="max-width:275px"/>
                    </div>
                    <div class="has-text-centered login-app-name">
                        <p class="subtitle is-6 has-text-primary">Online Reporting in the Extractives (ORE)</p>
                    </div>

                    <div class="notification is-danger"
                        v-if="errorData!=null">
                        <button class="delete"
                            type="button"
                            v-on:click="closeError"></button>
                        <strong>{{errorData.title}}</strong>
                        <p>{{errorData.message}}</p>
                    </div>

                    <b-field label="Username"
                        v-bind:label-position="labelPosition">
                        <b-input
                            v-model="username" 
                            value=""
                            maxlength="30"
                            required
                            v-on:keyup.native.13="checkUser"></b-input>
                    </b-field>

                    <b-field label="Password"
                        v-bind:label-position="labelPosition"
                        :message="isCapsOn==true ? 'Caps Lock is on.' : ''"
                        :type="isCapsOn==true ? 'is-info' : ''">
                        <b-input 
                            type="password"
                            v-model="password"
                            value=""
                            required
                            v-on:keyup.native.13="checkUser"
                            v-on:keyup.native="checkCaps($event,'pwd')"
                            password-reveal>
                        </b-input>
                    </b-field>
                
                    <div class="field">
                        <div class="control">
                            <a class="button is-success is-fullwidth"
                                v-on:click="checkUser"
                                v-bind:class="{'is-loading':isLoading}">
                                Sign In
                            </a>
                        </div>
                        <div class="separator-h"></div>
                        <div class="control has-text-left forgot-link">
                            <span class="has-text-black">Having trouble signing in?</span><br/>
                            <a class="is-link"
                                v-on:click="openForgotPassword">
                                Forgot Password
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="column is-1 separator-v"></div> -->
            <div class="column announcement-column">
                <div style="padding-top:1rem">
                    <div class="buttons">
                        <a class="button"
                            v-bind:class="activeTab=='posts' ? 'is-info' : 'is-light'"
                            v-on:click="showPosts">
                            Announcements
                        </a>
                        <a class="button"
                            v-bind:class="activeTab=='tracker' ? 'is-info' : 'is-light'"
                            v-on:click="showTracker">
                            FY 2021 Tracker
                        </a>
                    </div>

                    <LoginAnnouncements 
                        v-if="activeTab === 'posts'"/>
                    
                    <LoginReportTracker 
                        v-if="activeTab === 'tracker'"/>
                </div>
            </div>
        </div>
       
        <!-- Forgot Password Form -->
        <b-modal
            has-modal-card
            v-bind:active.sync="showForgotModal"
            v-bind:can-cancel="cancelOpts"
            v-on:close="closeForgotModal">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Forgot Password</p>
                </header>
                <section class="modal-card-body">
                    <p>Please fill in the necessary information.</p><br/>
                    <b-field
                        label="*Registered Email Address"
                        expanded>
                        <b-input 
                            v-model="forgotData.email"
                            type="text"
                            required
                            v-on:keyup.native.13="submitForgotData"></b-input>
                    </b-field>

                    <b-field
                        label="Username"
                        expanded>
                        <b-input 
                            v-model="forgotData.username"
                            type="text"
                            v-on:keyup.native.13="submitForgotData"></b-input>
                    </b-field>
                
                </section>
                <footer class="modal-card-foot has-text-left">

                    <a class="button is-white"
                        v-on:click="closeForgotModal">
                        <span>Cancel</span>
                    </a>
                    
                    
                    <a class="button is-success"
                        v-on:click="submitForgotData"
                        v-bind:disabled="!isEmailValid">
                        <span>Submit</span>
                    </a>
                </footer>
            </div>
        </b-modal>
    </section>
</template>

<style scoped>
.login-body {
    padding:0px;
    height: 100vh;
    width: 100vw;
}
.announcement-column {
    background-image: linear-gradient( #011541, #092257);
}
.login-box {
    margin: auto;
    padding: 0.8rem;
}
.login-app-name {
    margin-bottom: 1.2rem;
}

.login-box .field,
.login-box .label {
    color: #fff;
}
.forgot-link {
    margin-top: 1rem;
}
.separator-h {
    display:block;
    height:2px;
    width: 99%;
    margin:auto;
    margin-top: 1rem;
    margin-bottom: 0.7rem;
    border:none;
    border-bottom: 1px solid rgb(224, 224, 224);
}
.caption {
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/LoginView.vue